import React from "react";
import { Component } from "react";
import { match, RouteComponentProps } from "react-router";
import ReactTable from "react-table";
import AdminService from "../services/AdminService";
import { Donation } from '../components/Donation';
import { ModalComponent } from '../components/shared/ModalComponent';
import { flattenDiagnosticMessageText } from "typescript";

interface Props {
    eventId: string,
}

interface State {
    table2ColumnKey: any,
    table2: any,
    table2ColumnHeader: any,
    table3ColumnKey: any,
    table3: any,
    table3ColumnHeader: any,
    showTable2: boolean,
    showTable3: boolean,
    showImage1: boolean,
    image1: string,
    showImage2: boolean,
    image2: string,
    description: string,
    godName: string,
    loader: boolean
}

export class EventDetail extends Component<Props, State> {
    donateModal: ModalComponent
    constructor(props: any) {
        super(props);
        this.state = {
            table2ColumnKey: [],
            table2: [],
            table2ColumnHeader: [],
            table3ColumnKey: [],
            table3: [],
            table3ColumnHeader: [],
            showTable2: false,
            showTable3: false,
            showImage1: false,
            image1: "",
            showImage2: false,
            image2: "",
            description: "",
            godName: "",
            loader: false
        }
    }

    componentDidMount() {
        this.GetPageContent();
    }

    GetPageContent = async () => {
        
        this.setState({ loader: true })
        var god = await AdminService.GetTempleEventDetails(Number(this.props.eventId));
      
        if (god.value != null) {
            if (god.value.table1 != null && god.value.table1.length > 0) {
                this.setState({ godName: god.value.table1[0].GodName, description: god.value.table1[0].Description});

                if (god.value.table1[0].PrimaryImage != null && god.value.table1[0].PrimaryImage != "") {
                    this.setState({ image1: god.value.table1[0].PrimaryImage, showImage1: true });
                }
                if (god.value.table1[0].SecondaryImage != null && god.value.table1[0].SecondaryImage != "") {
                    this.setState({ image2: god.value.table1[0].SecondaryImage, showImage2: true });
                }
            }
            if (god.value.table2 != null && god.value.table2.length > 0) {
                this.setState({ table2ColumnKey: Object.keys(god.value.table2[0]), table2: god.value.table2, showTable2: true });
            }
            if (god.value.table3 != null && god.value.table3.length > 0) {
                this.setState({ table3ColumnKey: Object.keys(god.value.table3[0]), table3: god.value.table3, showTable3: true });
            }
        }
        this.RenderReactTable();
     this.setState({ loader: false })
    }

    ReactDynamicTableColumn = (data, type): any[] => {


        let dynamicColumn = [];

        if (data) {
            for (let column of data) {
                if (column != "EventId" && column != "AnnualSubscriptionId") {
                    dynamicColumn.push({
                        Header: column,
                        accessor: column
                    })
                }
            }
            dynamicColumn.push({
                Header: 'Action',
                Cell: this.renderDonateButton
            });
        }

        return dynamicColumn;
        
    }

    RenderReactTable = () => {
    
        var table2Column = this.ReactDynamicTableColumn(this.state.table2ColumnKey, 'primary');
        var table3Column = this.ReactDynamicTableColumn(this.state.table3ColumnKey, 'secondary');
        this.setState({ table2ColumnHeader: table2Column, table3ColumnHeader: table3Column});
    }

    renderDonateButton = (cellInfo) => {
  
        return <React.Fragment>
            <a className="btn btn-primary" style={{ color: "#fff" }} onClick={() => this.donationService(cellInfo)}>Donate</a>
        </React.Fragment>;
      
    }
    donationService = (cellInfo) => {
        this.donateModal.show();
    }

    render() {
        const { table2, table2ColumnHeader, table3, table3ColumnHeader, showTable2, showTable3,
            showImage1, image1, showImage2, image2, description, godName, loader } = this.state;
        return (
            <div className="god-template">
                     <div className={loader ? "show" : "hide"} id="loading">
          <div className="loading-spinner"></div>
        </div>
              
                <div className="img-container">
                    <div style={{ width: '50%', textAlign: 'center', padding: 2, margin: '0 auto' }}>
                        <h1>{godName}</h1>
                    </div>
                </div>
                <div className="row">
               
                    <div className="col-sm-3">
                        <div className={(showImage1 ? "show" : "hide") + ' col-sm-12'}>
                            <img src={image1} height={200} width={200} />
                        </div>
                        <br />
                        <div className={(showImage2 ? "show" : "hide") + ' col-sm-12'}>
                            <img src={image2} height={200} width={200} />
                        </div>
                    </div>
                    <div className="col-sm-9">
                        {description}
                    </div>
                
                </div>
                <br />
                <div className="events">
                    <div className="col-sm-12">
                        <div className="hidepagination">
                            {showTable2 ? <ReactTable
                                className={'fullwidth-table'}
                                data={table2}
                                columns={table2ColumnHeader}
                                defaultPageSize={10000}
                                minRows={5}
                                showPageSizeOptions={true}
                                showPagination={false}
                            /> : ""}

                        </div>
                    </div>
                    <br />
                    <div className="col-sm-12">
                        <div className={(table3 ? 'show' : 'hide')}>
                            <div className="hidepagination">
                                {showTable3 ? <ReactTable
                                    className="fullwidth-table"
                                    data={table3}
                                    columns={table3ColumnHeader}
                                    defaultPageSize={10000}
                                    minRows={5}
                                    showPageSizeOptions={true}
                                    showPagination={false}
                                /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalComponent
                    ref={x => this.donateModal = x}
                    buttons={<div>
                        <button type="button" className="btn bg-link" data-dismiss="modal" onClick={() => this.donateModal.hide()}>Close</button>
                    </div>}
                    dialogClassName="mx-width-100"
                    title={'Donation'}>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 feeback">
                                <Donation />
                            </div>
                        </div>
                    </div>
                </ModalComponent>
            </div>
        )
    }
}